export const MUNICIPAL_PROPERTY_SEGMENT = "properties";
export const MUNICIPAL_PROPERTY_BASE_PATH = `settings/workspace/${MUNICIPAL_PROPERTY_SEGMENT}`;
